// Per-supplier delivery breakdown for the cart / checkout summaries.
// Mirrors the backend's authoritative logic (order_routes._compute_delivery_charge):
// each supplier's delivery charge is computed on ITS OWN subtotal, then summed.
// This keeps multi-vendor carts accurate instead of applying one supplier's rate
// to the whole cart.
export function computeDeliveryBreakdown(items, supplierMetaMap = {}) {
  const ids = [...new Set((items || []).map(i => i.supplier_id).filter(Boolean))];
  const lines = ids.map(sid => {
    const meta = supplierMetaMap[sid];
    const subtotal = (items || [])
      .filter(i => i.supplier_id === sid)
      .reduce((s, i) => s + i.price * i.quantity, 0);
    const enabled = !!meta?.delivery_charge_enabled;
    const type = meta?.delivery_charge_type || 'fixed';
    const value = Number(meta?.delivery_charge_value || 0);
    let amount = 0;
    if (enabled && value > 0) {
      amount = type === 'percentage'
        ? +(subtotal * value / 100).toFixed(2)
        : +value.toFixed(2);
    }
    const name = meta?.name
      || (items || []).find(i => i.supplier_id === sid)?.supplier_name
      || 'Supplier';
    return { supplier_id: sid, name, type, value, subtotal: +subtotal.toFixed(2), amount };
  });
  const total = +lines.reduce((s, l) => s + l.amount, 0).toFixed(2);
  return { lines, total };
}
